// src/main.tsx
import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

// import { PostHogProvider } from 'posthog-js/react' //test

// const options = {
//   api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST
// }

// Initialize Sentry BEFORE React renders
// Only enable if explicitly enabled via VITE_SENTRY_ENABLED environment variable
if (import.meta.env.VITE_SENTRY_ENABLED === 'true' && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
    release: import.meta.env.VITE_SENTRY_RELEASE,
    
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    
    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false, // Set to true to mask all text in replays
        blockAllMedia: false, // Set to true to block all media in replays
      }),
      Sentry.browserProfilingIntegration(),
    ],
    
    // Performance Traces
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    // IMPORTANT: Trace propagation disabled until backend CORS is configured
    // The backend needs to allow these headers: sentry-trace, baggage
    // tracePropagationTargets: [
    //   "localhost",
    //   /^https:\/\/.*\.voicebot\.studio/,
    //   /^https:\/\/.*\.healvi-chat\.de/,
    // ],
    tracePropagationTargets: [], // Disabled - prevents CORS issues
    
    // Capture ALL errors (no sampling for errors)
    sampleRate: 1.0, // Capture 100% of errors
    
    // Session Replay
    replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0.1'),
    replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'),
    
    // Filter and process events before sending
    beforeSend(event) {
      // Filter out DevTools guard errors (these are intentional security measures)
      if (event.exception?.values?.[0]?.value?.includes('debugger')) {
        return null;
      }
      
      // Filter out intentional errors from DevToolsGuard
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
        frame => frame.filename?.includes('devToolsGuard')
      )) {
        return null;
      }
      
      return event;
    },
    
    // Add custom tags
    initialScope: {
      tags: {
        'app.section': 'frontend',
        'app.name': 'voicebot-frontend',
      },
    },
    
    // Ignore specific errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      'chrome-extension://',
      'moz-extension://',
      'safari-extension://',
      'safari-web-extension://',
      // Random network errors
      'NetworkError',
      'Network request failed',
      'Failed to fetch',
      'Load failed',
      // Cancelled requests
      'AbortError',
      'Request aborted',
      'canceled',
      // Browser quirks
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Script loading errors (often from ad blockers)
      /Loading chunk [\d]+ failed/,
      /Loading CSS chunk [\d]+ failed/,
      // Third-party scripts
      'Script error.',
      // WhatsApp SDK errors (non-actionable)
      'WhatsApp SDK',
    ],
  });
}

// Main entry point of the application
createRoot(document.getElementById('root')!).render(
    <App />
)
